// @flow
import React from 'react'
import { reduxForm, Field } from 'redux-form'
import Button from '../../../../components/Button'
import Input from '../../../../components/Input'
import Textarea from '../../../../components/Textarea'

type Props = {
  onSubmit: Function,
  submitting: boolean,
  handleSubmit: Function,
  onRequestClose: Function
}

const ContactForm = ({
  handleSubmit,
  submitting,
  onSubmit,
  onRequestClose
}: Props) => (
  <form onSubmit={handleSubmit(onSubmit)}>
    <div className="modal-header">
      <h5 style={{ marginBottom: 0 }}>Contact us</h5>
      <button type="button" className="modal-close" onClick={onRequestClose}>
        &times;
      </button>
    </div>
    <div className="modal-content">
      <Field
        name="name"
        label="Name"
        component={Input}
        style={{ marginBottom: '1rem' }}
      />
      <Field
        name="email"
        label="Email"
        component={Input}
        style={{ marginBottom: '1rem' }}
      />
      <Field
        rows={8}
        name="body"
        label="Message"
        component={Textarea}
        style={{ marginBottom: '1rem' }}
      />
    </div>
    <div className="modal-footer">
      <Button type="button" onClick={onRequestClose}>
        Cancel
      </Button>
      <Button
        color="primary"
        type="submit"
        disabled={submitting}
        animating={submitting}
      >
        Submit
      </Button>
    </div>
  </form>
)

const validate = (values) => {
  const errors = {}
  if (!values.name) {
    errors.name = 'Please enter name'
  }
  if (!values.email) {
    errors.email = 'Please enter email'
  }
  if (!values.body) {
    errors.body = 'Please enter message'
  }
  return errors
}

export default reduxForm({
  form: 'contact',
  validate
})(ContactForm)



// WEBPACK FOOTER //
// ./src/components/ContactModal/components/ContactForm/index.js